import getAllReasonsImport from './getAllReasons';
import getLenderDetailsImport from './getLenderDetails';
import getLendersImport from './getLenders';
import getMissedPaymentsImport from './getMissedPayments';
import getSuggestionsImport from './getSuggestions';
import getTullyRegistrationImport from './getTullyRegistration';

export const getAllReasons = getAllReasonsImport;
export const getLenderDetails = getLenderDetailsImport;
export const getLenders = getLendersImport;
export const getMissedPayments = getMissedPaymentsImport;
export const getSuggestions = getSuggestionsImport;
export const getTullyRegistration = getTullyRegistrationImport;
